import React from 'react';

import { Button, Flex } from '@opendoor/bricks/core';

interface MobileNavigationControlsProps {
  onGoToPrev: () => void;
  onGoToNext: () => void;
  onTouchStart: () => void;
  onTouchEnd: () => void;
}

/**
 * Mobile control buttons for going to the previous / next slide content.
 *   Non-visible Component doesn't need storybook test
 * storybook-check-ignore
 */
export const MobileNavigationControls: React.FC<MobileNavigationControlsProps> = ({
  onGoToPrev,
  onGoToNext,
  onTouchStart,
  onTouchEnd,
}) => {
  return (
    <Flex
      position="absolute"
      zIndex="10"
      width="100%"
      height="700px"
      justifyContent="center"
      alignItems="center"
      flexGrow={1}
    >
      <Button
        border="none"
        type="button"
        analyticsName="cake-welcome-to-hub-prev-step"
        background="transparent"
        aria-label="go to previous step"
        onClick={onGoToPrev}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        _hover={{
          background: 'transparent',
          border: 'transparent',
        }}
        _active={{
          background: 'transparent',
          border: 'transparent',
        }}
        sx={{
          WebkitTapHighlightColor: 'transparent',
          border: 'transparent',
        }}
        height="100%"
      />
      <Button
        border="none"
        type="button"
        analyticsName="cake-welcome-to-hub-next-step"
        background="transparent"
        aria-label="go to next step"
        onClick={onGoToNext}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        _hover={{
          background: 'transparent',
        }}
        _active={{
          background: 'transparent',
        }}
        sx={{
          WebkitTapHighlightColor: 'transparent',
        }}
        height="100%"
      />
    </Flex>
  );
};
